import React, { useRef, useMemo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { setHours, setMinutes, setSeconds, format, subDays } from 'date-fns';
import * as Yup from 'yup';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { Send } from '@material-ui/icons';
import { includes, isArray, isEmpty } from 'lodash';
import axios from 'axios';

import { DateTime, Autocomplete, Select, RadioGroup } from '~/components/Form';
import { GFO, GFU } from '~/constants/perfil';
import { t, parseDateString } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';

export default function Relresumoturno() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);

  const [intervalo, setIntervalo] = useState({}); // Intervalo do relatório
  const [posto, setPosto] = useState([]); // Posto
  const [datasTurnos, setDatasTurnos] = useState([]); // Data inicial do turno
  const [turnosCompletos, setTurnosCompletos] = useState([]); // Todos os turnos
  const [turnos, setTurnos] = useState([]); // Turno

  const [datasValue, setDatasValue] = useState('');
  const [turnosValue, setTurnosValue] = useState('');

  const formRef = useRef(null);

  const { glousuariotipo, glousuariologin } = useSelector(
    (state) => state.user.profile
  );
  const { token } = useSelector((state) => state.auth);

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const validation = useMemo(
    () => ({
      poco_codigo: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
      datahorainicial: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
      datahorafinal: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
    }),
    []
  );

  const validationSubmit = useMemo(
    () => ({
      poco_codigo: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
      datahorainicial: Yup.date()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .transform((_, value) => parseDateString(value))
        .required(t('s.geral.validacao.campoobrigatorio')),
      datahorafinal: Yup.date()
        .typeError(t('s.geral.validacao.campoobrigatorio'))
        .transform((_, value) => parseDateString(value))
        .required(t('s.geral.validacao.campoobrigatorio'))
        .max(datahorafinal, `A data não pode ser superior a ${datahorafinal}`)
        .min(
          Yup.ref('datahorainicial'),
          'A data não pode ser inferior a Data inicial'
        ),
      data: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
      turno: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .nullable(),
    }),
    []
  );

  const initials = useMemo(
    () => ({
      posto,
      datahorainicial,
      datahorafinal,
      datasTurnos,
      turnos,
      formato: 'pdf',
    }),
    [posto, datahorainicial, datahorafinal, datasTurnos, turnos]
  );

  function findTurnoPeloId(id) {
    return turnosCompletos.find((element) => {
      return element.turnCodigo === id;
    });
  }

  const handleSubmit = useCallback(
    async (data) => {
      try {
        setLoading(true);

        const schema = Yup.object().shape(validationSubmit);

        await schema.validate(data, {
          abortEarly: false,
        });

        const { datahorainicial, datahorafinal, formato, turno } = data;
        const { REACT_APP_URL_DOWNLOAD } = process.env;

        let poco_descricao = posto.poco_descricao;
        let unidadestr = posto.poco_descricao;
        let turnoSelecionado = findTurnoPeloId(turno);

        // compoe chamada com dados do turno selecionado
        let numeroturno = turnoSelecionado.turnNumero;
        let turnoinicio = turnoSelecionado.turnDataHoraInicioStr;
        let turnofim = turnoSelecionado.turnDataHoraFimStr;
        let operadorinicio = turnoSelecionado.usuaCodigoAbertura;
        let operadorfim = turnoSelecionado.usuaCodigoFechamento;
        let turnocodigo = turnoSelecionado.turnCodigo;

        let tipo = 'pdf';

        if (formato) {
          tipo = formato;
        }

        const url = new URL(REACT_APP_URL_DOWNLOAD);

        url.search = new URLSearchParams({
          relatorio: 'RESUMOTURNO',
          token,
          datahorainicial,
          datahorafinal,
          poco_descricao,
          unidadestr,
          numeroturno,
          turnoinicio,
          turnofim,
          operadorinicio,
          operadorfim,
          turnocodigo,
          tipo,
        });

        const response = await axios({
          url: url.href,
          method: 'GET',
          responseType: 'blob',
        });

        window.open(response.config.url)
        // const file = new Blob([response.data], { type: response.data.type });

        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(file);
        // } else {
        //   const objectUrl = URL.createObjectURL(file);
        //   window.open(objectUrl);
        // }
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message;
          });

          formRef.current.setErrors(validationErrors);
        } else {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        }
      } finally {
        setLoading(false);
      }
    },
    [turnosCompletos]
  );

  const handleFiltrar = useCallback(async () => {
    try {
      setLoading(true);

      // limpa lista
      setDatasTurnos([]);
      setTurnos([]);

      // limpa campos
      setDatasValue('');
      setTurnosValue('');
      formRef.current.setFieldValue('data', '');
      formRef.current.setFieldValue('turno', '');

      const formData = formRef.current.getData();
      const schema = Yup.object().shape(validation);

      await schema.validate(formData, {
        abortEarly: false,
      });

      const response = await api.get(
        `turnos/listadatasturno?unidade=${formData.poco_codigo}&dataInicio=${formData.datahorainicial}&dataFim=${formData.datahorafinal}`
      );

      let optDatasTurnos = [];

      if (!isEmpty(response.data)) {
        response.data.map((value) => {
          optDatasTurnos.push({ value: value, label: value });
        });
      }

      setDatasTurnos(optDatasTurnos);
    } catch (err) {
      setDatasTurnos([]);

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });

        formRef.current.setErrors(validationErrors);
      } else {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      }
    } finally {
      setLoading(false);
    }
  }, [validation]);

  async function handleDatasTurnos(dataTurno) {
    let optturnos = [];
    const formData = formRef.current.getData();

    formRef.current.setFieldValue('turno', '');

    const response = await api.get(
      `turnos/retornaturno?unidade=${formData.poco_codigo}&dataInicio=${dataTurno} 00:00:00&dataFim=${dataTurno} 23:59:59`,
      { params: { pesquisalista: true } }
    );

    if (!isEmpty(response.data)) {
      setTurnosCompletos(response.data);

      response.data.map((value) => {
        optturnos.push({
          value: value.turnCodigo,
          label:
            'Turno ' +
            value.turnNumero +
            ' - ' +
            value.turnDataHoraInicioStr.substring(11, 19),
        });
      });
    }

    setTurnos(optturnos);
  }

  const handleClearDatasTurnosAndTurnos = useCallback(() => {
    setDatasTurnos([]);
    setDatasValue('');
    setTurnos([]);
    setTurnosValue('');
    formRef.current.setFieldValue('data', '');
    formRef.current.setFieldValue('turno', '');
  }, []);

  const handleLookForDifference = useCallback(
    (field, value) => {
      if (intervalo[field] !== value) handleClearDatasTurnosAndTurnos();
    },
    [intervalo]
  );

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      open={open}
      onClise={() => setOpen(false)}
      maxWidth="sm"
    >
      <DialogTitle>Resumo de Turno</DialogTitle>
      <DialogContent>
        <S.Wrapper ref={formRef} onSubmit={handleSubmit} initialData={initials}>
          <Autocomplete
            name="poco_codigo"
            label="poco_descricao"
            title="Posto"
            url="postosporusuario"
            unique="poco_codigo"
            params={[{ orderfield: 'poco_codigo' }]}
            disabled={includes([GFO, GFU], glousuariotipo)}
            getValue={(value) => {
              setPosto(value);
              setDatasValue('');
              setTurnosValue('');
              formRef.current.setFieldValue('data', '');
              formRef.current.setFieldValue('turno', '');
            }}
            onInputChange={handleClearDatasTurnosAndTurnos}
          />

          <DateTime
            time
            label="Data Inicial"
            name="datahorainicial"
            onBlur={(value) =>
              handleLookForDifference('start', value.target.value)
            }
            onAccept={handleClearDatasTurnosAndTurnos}
            getValue={(value) => {
              setIntervalo((state) => ({ ...state, start: value }));
            }}
            disableFuture
          />

          <DateTime
            time
            label="Data Final"
            name="datahorafinal"
            onBlur={(value) =>
              handleLookForDifference('end', value.target.value)
            }
            onAccept={handleClearDatasTurnosAndTurnos}
            getValue={(value) => {
              setIntervalo((state) => ({ ...state, end: value }));
            }}
            disableFuture
          />

          <Button
            type="button"
            startIcon={<Send />}
            color="default"
            variant="outlined"
            onClick={handleFiltrar}
          >
            FILTRAR
          </Button>

          <Select
            name="data"
            variant="outlined"
            size="small"
            label="Datas"
            options={datasTurnos}
            getValue={(value) => {
              setDatasValue(value);
              handleDatasTurnos(value);
            }}
            value={datasValue}
          />

          <Select
            name="turno"
            variant="outlined"
            size="small"
            label="Turnos"
            options={turnos}
            getValue={(value) => {
              setTurnosValue(value);
            }}
            value={turnosValue}
          />

          <RadioGroup
            row
            name="formato"
            label="Formato"
            options={[
              { label: 'PDF', value: 'pdf' },
              { label: 'Excel', value: 'xls' },
            ]}
            defaultValue="pdf"
            serialize={(value) => value}
          />
        </S.Wrapper>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="outlined"
          onClick={() => formRef.current.submitForm()}
          disabled={loading}
        >
          Exibir
        </Button>

        <Button
          color="secondary"
          variant="outlined"
          onClick={() => setOpen(false)}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

/*
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Button } from '@material-ui/core';
import { Send } from '@material-ui/icons';

import moment from 'moment';
import { isEmpty } from 'lodash';

import { Report } from '~/components';
import { DateTime, Autocomplete, Select, RadioGroup } from '~/components/Form';

import { GPP } from '~/constants/perfil';

import * as Yup from 'yup';
import { t } from '~/helpers';

import api from '~/services/api';

function Relresumoturno() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valuePosto, setValuePosto] = React.useState('');
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [dataInicio, setDataInicio] = React.useState('');
  const [dataFim, setDataFim] = React.useState('');

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const { profile } = useSelector((state) => state.user);

  const [disablePosto, setDisablePosto] = useState(false);

  const [datas, setDatas] = useState([]);
  const [data, setData] = useState('');

  const [turnos, setTurnos] = useState([]);
  const [turnosCompletos, setTurnosCompletos] = useState([]);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        poco_codigo: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        data: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        turno: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GPP) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  useEffect(() => {
    if (dataInicio === '') {
      setDataInicio(start.format('DD/MM/YYYY HH:mm:ss'));
      setDataFim(end.format('DD/MM/YYYY HH:mm:ss'));
    }
  }, [start, end]);

  async function handleFiltrar() {
    const response = await api.get(
      `turnos/listadatasturno/?unidade=${valuePosto}&dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    if (!isEmpty(response.data)) {
      let optdatas = [];
      response.data.map((value) => {
        optdatas.push({ value: value, label: value });
      });
      setDatas(optdatas);
    } else {
      setDatas([]);
    }
  }

  async function handleTurnosData(vdata) {
    const response = await api.get(
      `turnos/retornaturno/?unidade=${valuePosto}&dataInicio=${vdata} 00:00:00&dataFim=${vdata} 23:59:59`
    );
    if (!isEmpty(response.data)) {
      setTurnosCompletos(response.data);
      let optturnos = [];
      response.data.map((value) => {
        optturnos.push({
          value: value.turnCodigo,
          label:
            'Turno ' +
            value.turnNumero +
            ' - ' +
            value.turnDataHoraInicioStr.substring(11, 19),
        });
      });
      setTurnos(optturnos);
    } else {
      setTurnos([]);
    }
  }

  function findTurnoPeloId(id) {
    return turnosCompletos.find((element) => {
      return element.turnCodigo === id;
    });
  }

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let unidadestr = '';
    if (params.poco_descricao) {
      unidadestr = params.poco_descricao;
    } else {
      unidadestr = '';
    }

    let turnoSelecionado = findTurnoPeloId(params.turno);

    // compoe chamada com dados do turno selecionado
    let numeroturno = turnoSelecionado.turnNumero;
    let turnoinicio = turnoSelecionado.turnDataHoraInicioStr;
    let turnofim = turnoSelecionado.turnDataHoraFimStr;
    let operadorinicio = turnoSelecionado.usuaCodigoAbertura;
    let operadorfim = turnoSelecionado.usuaCodigoFechamento;
    let turnocodigo = turnoSelecionado.turnCodigo;

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      unidadestr,
      numeroturno,
      turnoinicio,
      turnofim,
      operadorinicio,
      operadorfim,
      turnocodigo,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Resumo de Turno"
      relatorio="RESUMOTURNO"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        poco_codigo: valuePosto,
      }}
    >
      <Autocomplete
        name="poco_codigo"
        label="poco_desc_abrev"
        title="Posto"
        id="poco_codigo"
        url="postoscomboios"
        unique="poco_codigo"
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        defaultValue=""
        hiddens={[{ name: 'poco_desc_abrev' }]}
        getValue={(value) => {
          if (value.poco_codigo !== null) {
            setValuePosto(value.poco_codigo);
          } else {
            setValuePosto('');
          }

          setDatas([]);
          setTurnos([]);
        }}
        disabled={disablePosto}
      />

      <DateTime
        label="Data Inicial"
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
        getValue={(value) => {
          if (value !== null) {
            setDataInicio(value);
          } else {
            setDataInicio('');
          }

          setDatas([]);
          setTurnos([]);
        }}
      />

      <DateTime
        label="Data Final"
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
        getValue={(value) => {
          if (value !== null) {
            setDataFim(value);
          } else {
            setDataFim('');
          }

          setDatas([]);
          setTurnos([]);
        }}
      />

      <Button
        startIcon={<Send />}
        color="terciary"
        variant="outlined"
        onClick={(params) => handleFiltrar(params)}
      >
        Filtrar
      </Button>

      <div style={{ bottom: '0 10px' }}></div>

      <Select
        name="data"
        variant="outlined"
        size="small"
        label="Datas"
        options={datas}
        getValue={(value) => {
          setData(value);
          handleTurnosData(value);
        }}
      />

      <Select
        name="turno"
        variant="outlined"
        size="small"
        label="Turnos"
        options={turnos}
      />

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relresumoturno;
*/
